import { ReactComponent as DockIcon } from 'assets/icons/dock.svg'
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg'
import { ReactComponent as CheckIcon } from 'assets/icons/check.svg'

import SessionBadges from '../SessionBadges/SessionBadges'
import ResourceActionsCurriculum from '../ResourceActionsCurriculum/ResourceActionsCurriculum'

import useSessionRow from './hooks/useSessionRow'

import s from './styles/SessionRow.module.scss'

const SessionRow = ({
	session,
	isLast = false,
	onResourceClick,
	onAssignmentClick,
	onMarkComplete,
}) => {
	const {
		isCompleted,
		isCurrent,
		isUpcoming,
		isOpen,
		isConfigurePrimary,
		isConfigureOutline,
		completedDateLabel,
		handleResourceClick,
		handleAssignmentClick,
		handleMarkComplete,
	} = useSessionRow({
		session,
		onResourceClick,
		onAssignmentClick,
		onMarkComplete,
	})

	return (
		<div
			className={`${s.row}
			${isCompleted ? s.completed : ''}
			${isCurrent ? s.current : ''}
			${isUpcoming ? s.upcoming : ''}`}
		>
			<div
				className={`${s.step}
					${isCompleted ? s.done : ''}
					${isCurrent ? s.current : ''}
					${isUpcoming ? s.upcoming : ''}
					${isLast ? s.last : ''}`}
			>
				<div className={`${s.step__label}`}>S{session.order}</div>
			</div>

			<div className={s.content}>
				<div className={s.info}>
					<SessionBadges status={session.status} />
					<h3 className={s.title}>{session.title}</h3>
					<p className={s.subtitle}>{session.subtitle}</p>
				</div>

				<div className={s.resources}>
					<span className={s.resourcesLabel}>Resources</span>
					<ResourceActionsCurriculum
						resources={session.resources}
						onResourceClick={handleResourceClick}
					/>
				</div>

				<div className={s.actions}>
					<button
						type="button"
						className={`${s.actionBtn}
						${isOpen ? s.actionBtn_outline : ''}
						${isConfigurePrimary ? s.actionBtn_primary : ''}
						${isConfigureOutline ? s.actionBtn_accent : ''}`}
						onClick={handleAssignmentClick}
					>
						<span className={s.actionBtn__icon}>
							{isOpen ? (
								<DockIcon />
							) : (
								(isConfigurePrimary || isConfigureOutline) && <PlusIcon />
							)}
						</span>
						<span>{session.status?.actionLabel}</span>
					</button>

					{isCompleted ? (
						<div className={`${s.actionBtn} ${s.actionBtn_completed}`} aria-label="Session completed">
							<span>Completed</span>
							{completedDateLabel ? (
								<span className={s.actionBtn__completedDate}>{completedDateLabel}</span>
							) : null}
						</div>
					) : (
						<button
							type="button"
							className={`${s.actionBtn} ${s.actionBtn_mark}`}
							onClick={handleMarkComplete}
						>
							<span className={s.actionBtn__icon}>
								<CheckIcon />
							</span>
							<span>Mark Complete</span>
						</button>
					)}
				</div>
			</div>
		</div>
	)
}

export default SessionRow
